import { claimTokens, } from "@bracket/contractor-next/bracket-escrow";
import type { BlockHash, EthereumAddress, } from "@bracket/types";
import { wagmiConfig as config, } from "@wagmiconfig";
import { applyClaim, } from "./applyClaim";


export declare type ClaimProps = {
	address: EthereumAddress;
	amount: bigint;
	proof: string[];
	email: string;
};


export const claim = async ({ amount, proof, email, address, }: ClaimProps): Promise<BlockHash|null> => {
	
	if(!proof || !amount || !proof.length) {
		throw new Error("no address, claim_proof, or claim_amount");
	}

	try {

		const hash = await claimTokens({ token: "BRKTETH", proof, amount: BigInt(amount), config, });
		if(hash) {
			const success = await applyClaim({ email, amount, address, });
			if(success) {
				return hash;
			}
			console.warn("failed to apply claim");
			return hash;
		}

		throw new Error("failed to obtain a resulting block hash");
	}
	catch( err ) {

		console.warn(`@bracket/platform/client/store/wallet/resolvers/escrow/claim has failed - ${err instanceof Error ? err.message : "unknown error"}`);
		return null;
	}

};
